// extracted by mini-css-extract-plugin
export var active = "_6k-a";
export var activeIndicator = "_6k-9";
export var disabled = "_6k-b";
export var fullWidth = "_6k-2";
export var lg = "_6k-7";
export var md = "_6k-6";
export var redoButtonTabGroup = "_6k-0";
export var sm = "_6k-5";
export var tabButton = "_6k-4";
export var tabButtonsContainer = "_6k-1";
export var themeDestructive = "_6k-d";
export var themeNormal = "_6k-c";
export var themeSuccess = "_6k-e";
export var xl = "_6k-8";
export var xs = "_6k-3";